import { useNotifier } from '@provider/notifier';
import { DownloadIcon, colors } from '@ui/kit';
import { UniversalContextMenuButton } from '../molecule.contextmenu.js';
import { icon } from './button.style.js';
import { useExport } from './hook.export.js';
import { makeExportModalConfig } from './modal.js';
import { jsx } from 'react/jsx-runtime';

function LegacyExportButton(props) {
  const notifier = useNotifier();
  const showModal = !props.targets || props.targets.pdf && props.targets.word;
  const state = useExport(props.input, {
    format: props.targets?.pdf ? "pdf" : "docx",
    css: props.printCss,
    orientation: props.printOrientation ?? "portrait",
    componentTitle: props.componentTitle,
    hideIrrelevantDOMNodesBeforeExport: props.hideIrrelevantDOMNodesBeforeExport,
    onBeforeExport: props.onBeforeExport,
    onAfterHTMLSent: props.onAfterHTMLSent,
    onAfterExport: props.onAfterExport
  });
  const tooltip = (() => {
    if (showModal) {
      return "Download";
    }
    if (props.targets?.pdf) {
      return "Download PDF";
    }
    if (props.targets?.word) {
      return "Download Word";
    }
    return "Download";
  })();
  const onClick = () => {
    props.onClick?.();
    if (showModal) {
      return notifier.modal(makeExportModalConfig(props));
    } else {
      return state.export();
    }
  };
  return /*#__PURE__*/jsx(UniversalContextMenuButton, {
    as: "button",
    layout: props.layout,
    label: tooltip,
    onClick: onClick,
    async: typeof state.progress !== "undefined" ? {
      progress: state.progress
    } : undefined,
    state: !state.progress && state.hasExported ? "success" : undefined,
    icon: /*#__PURE__*/jsx(DownloadIcon, {
      className: icon,
      height: 20,
      color: state.progress ? colors.success() : undefined,
      fillPercentage: state.progress ? state.progress * 100 : undefined
    })
  });
}

export { LegacyExportButton };
//# sourceMappingURL=button.js.map
